// extracted by mini-css-extract-plugin
export var alert = "Alert-module--alert--b5325";
export var center = "Alert-module--center--268d2";
export var gold = "Alert-module--gold--96170";
export var hidden = "Alert-module--hidden--fbdf7";
export var light = "Alert-module--light--b86b0";
export var red = "Alert-module--red--3edf8";
export var transparent = "Alert-module--transparent--4dd25";